import styles from './Design2.css?inline';

export class BannerDesign2 {
  private autocompleteInput!: HTMLInputElement;
  private autocompleteList!: HTMLUListElement;
  private containerElement: HTMLDivElement;

  constructor(
    private language: string,
    private widgetData: any,
    private response: any
  ) {
    this.containerElement = this.createContainer();
    this.injectStyles();
  }

  getContainer() {
    return this.containerElement;
  }

  getInput() {
    return this.autocompleteInput;
  }

  getList() {
    return this.autocompleteList;
  }

  private injectStyles() {
    const styleId = 'dabadu-trade-in-design2-styles';
    if (!document.getElementById(styleId)) {
      const styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.innerHTML = styles;
      document.head.appendChild(styleTag);
    }
  }

  private createContainer(): HTMLDivElement {
    const container = document.createElement('div');
    container.id = 'trade-in-search-container-view';
    container.className = `trade-in-search2 design-2 ${this.widgetData.customClassName || ''}`;

    container.appendChild(this.createAutocompleteContainer());
    container.appendChild(this.createLabel()); // label comes after input
    container.appendChild(this.createPoweredByContainer());

    return container;
  }

  private createLabel(): HTMLDivElement {
    const label = document.createElement('div');
    label.className = 'trade-in-search2__lbl';
    label.innerText = this.getTranslation(
      'Check your Trade-in Value Now!',
      'Vérifiez la valeur de reprise de votre véhicule maintenant!',
      '¡Consulta el valor de tu intercambio ahora!'
    );
    return label;
  }

  private createAutocompleteContainer(): HTMLDivElement {
    const container = document.createElement('div');
    container.className = 'form-group';
    container.id = 'autocomplete-container';

    const input = document.createElement('input');
    input.type = 'text';
    input.id = 'autocomplete-input';
    input.className = 'form-control dabadu-widget';
    input.placeholder = this.getTranslation(
      'Search Make / Model',
      'Rechercher Marque / Modèle',
      'Buscar Marca / Modelo'
    );
    input.autocomplete = 'off';

    const list = document.createElement('ul');
    list.id = 'autocomplete-list';
    list.className = 'autocomplete-list';

    container.appendChild(input);
    container.appendChild(list);

    this.autocompleteInput = input;
    this.autocompleteList = list;

    return container;
  }

  private createPoweredByContainer(): HTMLDivElement {
    const container = document.createElement('div');
    container.className = 'powered-by';

    const label = document.createElement('div');
    label.className = 'powered-by__lbl';
    label.innerText = this.getTranslation('Powered By', 'Propulsé par', 'Impulsado por');

    const logo = document.createElement('img');
    logo.src = 'https://s3.ca-central-1.amazonaws.com/widget-uat.dabadu.dev/dabadu-logo.png';
    logo.alt = 'Dabadu';
    logo.className = 'img-fluid';

    container.appendChild(label);
    container.appendChild(logo);

    return container;
  }

  private getTranslation(en: string, fr: string, es: string): string {
    return { en, fr, es }[this.language] || en;
  }
}
